/* istanbul ignore file */
export default () => {
    if (typeof window !== 'undefined') {
        return window.location !== window.parent.location
    }
    return false
}
